import React, { useEffect } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import aboutpic from '../assets/images/som.png';
import AOS from 'aos';
import { useTranslation } from 'react-i18next';
import 'aos/dist/aos.css'; 

export default function About() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1000,  
      easing: 'ease-out', 
      once: true, 
    });
  }, []);

  return (
    <>
      <Navbar />
      <div className="min-h-screen w-full bg-[#1f1f2c] relative flex flex-col items-center justify-center antialiased py-10 sm:py-20">
        
        <div className="absolute inset-0 bg-[#1f1f2c] backdrop-blur-lg opacity-60 z-0 sm:opacity-40 md:opacity-60"></div>


        <div className="max-w-7xl w-full mx-auto px-6 flex flex-col lg:flex-row items-center lg:items-start justify-between gap-16 relative z-10">

        <div className="w-full lg:w-[60%] flex justify-center items-center relative">
  <img
    src={aboutpic}
    alt="Jun Yazılım"
    className="
      w-full 
      h-auto 
      object-cover

      /* Mobil & Tablet (0–1023px) için */
      absolute 
      top-0 
      left-0 
      z-0 
      opacity-20 
      blur-sm

      /* Desktop (≥1024px) için */
      lg:static 
      lg:mt-20
      lg:left-auto 
      lg:opacity-100 
      lg:blur-0 
      lg:z-10
    "
  />
</div>






          
          {/* Text Section */}
          <div className="w-full lg:w-[40%] text-start mt-10 lg:mt-20 relative z-10">
            <h1
              className="text-2xl sm:text-3xl md:text-3xl text-[#dcbc5c] font-aventa mb-6"
              data-aos="fade"
              data-aos-delay="200"  
              data-aos-duration="1000"  
              aria-label="Hakkımızda"
            >
              {t('about')}
            </h1>
            <p
              className="text-white my-4 text-base"
              data-aos="fade"
              data-aos-delay="300" 
              data-aos-duration="1000" 
            >
              {t('aboutsection')}
            </p>

            <p
              className="text-white my-4 text-base"
              data-aos="fade"
              data-aos-delay="400" 
              data-aos-duration="1000"
            >
              {t('aboutsection1')}
            </p>

            <p
              className="text-white my-4 text-base"
              data-aos="fade"
              data-aos-delay="500"  
              data-aos-duration="1000"
            >
              {t('aboutsection2')}
            </p>

            <p
              className="text-white my-4 text-base"
              data-aos="fade"
              data-aos-delay="550"  
              data-aos-duration="1000"
            >
              {t('aboutsection3')}
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
